import React from "react";

const InputGroup = ({ icon: Icon, inputClassName, ...rest }) => {
  return (
    <div className="relative">
      <span className="absolute inset-y-0 left-0 flex items-center pl-2">
        {Icon && Icon}
      </span>
      <input
        type="text"
        className={`pl-8 h-10 pr-2 bg-zinc-600 appearance-none rounded w-full leading-tight focus:outline-none focus:shadow-outline caret-yellow-500 ${inputClassName}`}
        {...rest}
      />
    </div>
  );
};


export default InputGroup;
